import { render } from "./ShopAdmin.vue?vue&type=template&id=264ee91c&scoped=true"
import script from "./ShopAdmin.vue?vue&type=script&lang=js"
export * from "./ShopAdmin.vue?vue&type=script&lang=js"

import "./ShopAdmin.vue?vue&type=style&index=0&id=264ee91c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264ee91c"]])

export default __exports__